<template>
    <div id="visitorChatList">
        <div class="page-tabs">
            <div
                class="tab-item"
                :class="{ active: tabKey === 'visitor-messages' }"
                @click="changeTabKey('visitor-messages')"
            >
                <span class="material-icons">forum</span>
                Mesaj Geçmişi
            </div>
            <div
                class="tab-item"
                :class="{ active: tabKey === 'conversation-history' }"
                @click="changeTabKey('conversation-history')"
            >
                <span class="material-icons">chat</span>
                Geçmiş Sohbetler
            </div>
        </div>
        <div class="visitor-chat-content" v-if="contact">
            <template v-if="tabKey === 'conversation-history'">
                <a-spin :spinning="loading">
                    <div v-if="chats.length > 0">
                        <div id="visitor-history-list" style="top: 90px; bottom: 30px; width: 100%">
                            <div v-for="chat of chats" class="item" @click="() => selectChat(chat)">
                                <div style="margin-right: 28px">
                                    <a-avatar
                                        :size="40"
                                        :src="chat.users.length ? chat.users[0].gravatar : undefined"
                                        :style="{ backgroundColor: '#ffa800' }"
                                        :username="chat.users.length ? chat.users[0].name : chat.fullname"
                                    >
                                        <div style="font-size: 14px">
                                            {{
                                                ((chat.fullname ? chat.fullname : "User") || "*")
                                                    .substr(0, 1)
                                                    .toUpperCase()
                                            }}
                                        </div>
                                    </a-avatar>
                                </div>
                                <div class="content w-100">
                                    <div class="d-flex justify-content-between w-100">
                                        <span class="participant">{{ chat.fullname }}</span>
                                        <span class="time">{{ getDate(chat) }}</span>
                                    </div>
                                    <div class="visitor-messages">
                                        <span v-html="messageText(getLastMessage(chat).description)"></span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="mt-5">
                            <a-pagination v-model:current="page" show-quick-jumper :total="totalCount" />
                        </div>
                    </div>
                    <div class="data-box" v-else>
                        <div class="last-session-info">
                            <div class="material-icons" style="font-size: 20px">block</div>
                            <div class="last-session-data" style="margin-top: 5px">{{ $t("visitor.notUserData") }}</div>
                        </div>
                    </div>
                    <UserChatHistoryWidget
                        v-if="showConversationHistory && activeConversation"
                        :visitor-id="activeConversation.visitor"
                        :conversation-id="activeConversation._id"
                        @close="closeChatHistory"
                    />
                </a-spin>
            </template>
            <template v-if="tabKey === 'visitor-messages'">
                <ChatWindow :contact="contact" :is-live="false" :show-header="false" />
            </template>
        </div>
    </div>
</template>

<script>
import { log2 } from "../../../utils/log2";
import moment from "moment";
import { fetchChatHistory } from "../../../api/visitor";
import { htmlUnescape } from "escape-goat";
import Autolinker from "autolinker";
import { mapState } from "vuex";
import { getContactById } from "../../../api/chat";

const log = log2("VisitorChatList");

export default {
    name: "VisitorChatList",
    components: {
        ChatWindow: () => import("../../../components/popup-chat/chat-window/ChatWindow.vue"),
        UserChatHistoryWidget: () => import("../../../components/UserChatHistoryWidget.vue"),
    },
    props: {
        visitorId: {
            type: String,
        },
    },
    data: () => ({
        contact: null,
        chats: [],
        loading: true,
        totalCount: 10,
        pageSize: 1,
        page: 1,
        perPage: 5,
        conversation: [],
        showConversationHistory: false,
        activeConversation: null,
        tabKey: "visitor-messages",
    }),
    computed: {
        ...mapState({
            site: (state) => state.site.site,
        }),
    },
    mounted() {
        moment.locale(this.$i18n.locale);
        this.getChatHistory();
        getContactById(this.visitorId).then((res) => {
            this.contact = res.data;
        });
    },
    methods: {
        changeTabKey(key) {
            this.tabKey = key;
        },
        selectChat(c) {
            if (c && c._id) {
                this.activeConversation = {
                    _id: c._id,
                    visitor: this.visitorId,
                };
                this.showConversationHistory = true;
                this.$emit("detailClose");
            }
        },
        closeChatHistory() {
            this.showConversationHistory = false;
            this.activeConversation = null;
        },
        getFirstMessage(c) {
            log("getFirstMessage", { c, test: c.messages[c.messages.length - 2] });
            return c.messages[c.messages.length - 2];
        },
        messageText(msg) {
            log("messageText...", msg);

            let escaped = htmlUnescape(msg.trim());

            let res = Autolinker.link(escaped, {
                className: "chatLink",
                truncate: { length: 50, location: "smart" },
            });

            res = res.replace(/<p>&nbsp;<\/p>$/gi, "");

            const regexp = /image/g;
            const matches = res.match(regexp);

            if (!!matches) {
                const regexp2 = /<img\b[^>]*>/g;
                const updatedHtml = res.replace(regexp2, '<img style="height: 40px; width:40px"$&');

                return updatedHtml;
            } else {
                return res;
            }
        },
        getLastMessage(c) {
            log("getLastMessage", c);
            return c.messages[c.messages.length - 1];
        },
        getDate(c) {
            return moment(c.createdDate).fromNow();
        },
        getChatHistory() {
            this.loading = true;
            fetchChatHistory(this.site._id, this.visitorId, this.page, this.perPage).then((res) => {
                const { conversations, totalCount, currentPage, pageSize } = res.data;
                this.totalCount = totalCount;
                this.pageSize = Math.ceil(totalCount / this.perPage);
                this.chats = conversations.filter((x) => x.messages.length > 0);
                this.loading = false;
            });
        },
    },
    watch: {
        page() {
            this.getChatHistory();
        },
    },
};
</script>

<style lang="scss">
#visitorChatList {
    height: 100%;
    display: flex;
    flex-direction: column;

    .visitor-chat-content {
        position: relative;
        overflow-y: auto;
        overflow-x: hidden;
        max-height: calc(100vh - 200px);
        height: auto;
        min-height: 400px;
        padding: 10px;
        border: 1px solid #e5e7eb;
        border-radius: 5px;
        margin: 10px 0;
    }

    .page-tabs {
        display: flex;
        background-color: #fff;
        border-bottom: 1px solid #e5e7eb;
        overflow-x: auto;
        scrollbar-width: thin;
        padding: 0 8px;
        position: sticky;
        top: 0;
        z-index: 5;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.03);

        &::-webkit-scrollbar {
            height: 3px;
        }

        &::-webkit-scrollbar-thumb {
            background-color: rgba(0, 0, 0, 0.15);
            border-radius: 10px;
        }

        .tab-item {
            padding: 0 14px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 13px;
            font-weight: 500;
            color: #6b7280;
            cursor: pointer;
            white-space: nowrap;
            transition: all 0.2s ease;
            border-bottom: 2px solid transparent;
            height: 42px;
            position: relative;
            margin: 0 2px;

            .material-icons {
                font-size: 18px;
                margin-right: 6px;
                width: 18px;
                height: 18px;
                display: flex;
                align-items: center;
                justify-content: center;
                transition: all 0.2s ease;
                opacity: 0.85;
            }

            &::after {
                content: "";
                position: absolute;
                bottom: -1px;
                left: 0;
                width: 100%;
                height: 2px;
                background-color: #6366f1;
                transform: scaleX(0);
                transition: transform 0.25s ease;
                border-radius: 2px 2px 0 0;
            }

            &:hover {
                color: #4b5563;
                background-color: rgba(243, 244, 246, 0.7);

                .material-icons {
                    opacity: 1;
                }
            }

            &.active {
                color: #6366f1;
                font-weight: 600;
                background-color: rgba(99, 102, 241, 0.06);

                &::after {
                    transform: scaleX(0.85);
                }

                .material-icons {
                    color: #6366f1;
                    opacity: 1;
                }
            }
        }
    }

    #visitor-history-list {
        color: var(--color7) !important;
        display: flex;
        flex-direction: column;
        border: 1px solid #dbe1e8;

        .last-session-data {
            max-width: 200px;
            color: #516173;
            font-weight: 500;
            font-size: 14px;
            line-height: 20px;
        }

        .data-box {
            border: 1px solid #dbe1e8;
            border-radius: 4px;
            -webkit-box-shadow: 0 1px 1px 0 rgb(0 0 0 / 13%);
            box-shadow: 0 1px 1px 0 rgb(0 0 0 / 13%);
            padding: 25px;
            display: grid;
            width: 100%;
        }

        .last-session-info {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
        }

        .item {
            width: 100%;
            display: flex;
            padding: 14px 14px;
            cursor: pointer;
            align-items: center;
            border-bottom: 1px solid #dbe1e8;

            .content {
                padding-left: 4px;
                overflow: hidden;
            }

            .time {
                font-size: 16px;
                line-height: 20px;
                color: #516173;
                font-weight: 500;
            }

            .participant {
                color: #22272d;
                font-weight: 500;
                font-size: 16px;
                line-height: 20px;
                width: 70%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }

            .visitor-messages {
                .chatLink {
                    color: #516173 !important;
                }

                span {
                    max-height: 60px;
                    -webkit-line-clamp: 3;
                    font-size: 15px;
                    margin-top: 5px;
                    color: #516173;
                }
            }
        }
    }
}
</style>
